import * as config from '../config/config';
import { request, checkNested } from './utils';
import wx from 'weixin-js-sdk';

class WXJS {
  getWXSign() {
    const url = config.API.getjsapiinfo(encodeURIComponent(location.href.split('#')[0]));
    return new Promise((resolve, reject) => request.get(url).then((res) => {
      if (checkNested(res, 'data', 'content', 'model')) {
        const model = res.data.content.model;
        wx.config({
          beta: true,
          debug: false,
          appId: model.corpId,
          timestamp: model.timeStamp,
          nonceStr: model.nonceStr,
          signature: model.signature,
          jsApiList: ['scanQRCode', 'chooseImage', 'uploadImage']
        });
        wx.error((res) => {
        });
        wx.ready(() => {
          resolve();
        });
      } else {
        reject(res.content.message);
      }
    }));
  }
}
export default new WXJS();

